
declare let require: any;


export class Security {

    readonly IV_SIZE: number = 16;
    cryptojs = require("crypto-js");
    constructor() { }

    public encryptAES(value: string, key: string): string {
        let iv = this.cryptojs.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        const ecrypted = this.cryptojs.AES.encrypt(JSON.stringify(value), this.cryptojs.enc.Utf8.parse(key), { iv });
        return ecrypted.toString();
    }

    public decryptAES(value: string, key: string): string {
        let iv = this.cryptojs.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        const decrypted = this.cryptojs.AES.decrypt(value, this.cryptojs.enc.Utf8.parse(key), { iv });
        return decrypted.toString(this.cryptojs.enc.Utf8);
    }

    public base64ToString(cadena: string) {
        const words = this.cryptojs.enc.Base64.parse(cadena);
        return this.cryptojs.enc.Utf8.stringify(words);
    }

}